import React, { useEffect, useState } from "react";
import * as API from "../../Utils/Services/api";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const EditAdminCoinModal = ({ show, onHide, coin, onSave }) => {
  const [editedCoin, setEditedCoin] = useState({
    tokenImage: null,
    description: "",
    imagePreview: "",
  });
  useEffect(() => {
    console.log("Edit Modal received coin:", coin);
  }, [coin]);

  useEffect(() => {
    if (coin) {
      setEditedCoin({
        tokenImage: null,
        imagePreview: coin.tokenImage || coin.image || "",
        description: coin.description || "",
      });
    }
  }, [coin]);

  const handleSave = async () => {
    try {
      const formData = new FormData();
      if (editedCoin.tokenImage) {
        formData.append("tokenImage", editedCoin.tokenImage); // File
      }
      formData.append("description", editedCoin.description);
      const updatedCoin = {
        ...coin,
        tokenImage: editedCoin.imagePreview,
        description: editedCoin.description,
      };
      await API.updateCoinDetails(coin.id, formData);

      onSave(updatedCoin);
      onHide();
      toast.success("Details Updated successfully");
    } catch (err) {
      console.error("Failed to update coin:", err);
      alert("Error updating coin. Please try again.");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Coin</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="text-center">
            <strong>
              Be Careful <br /> You are about to change the official coins image
              and description visible on platform!
            </strong>{" "}
          </div>{" "}
          <br />
          <Form.Group className="mb-3">
            <Form.Label>Upload Image</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  setEditedCoin((prev) => ({
                    ...prev,
                    tokenImage: file,
                    imagePreview: URL.createObjectURL(file),
                  }));
                }
              }}
            />
            <div className="mt-2 text-center">
              {editedCoin.imagePreview && (
                <img
                  src={editedCoin.imagePreview}
                  alt="Preview"
                  style={{
                    maxHeight: 100,
                    borderRadius: 5,
                    marginTop: "20px",
                    marginBottom: "10px",
                  }}
                />
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={editedCoin.description}
              onChange={(e) =>
                setEditedCoin({
                  ...editedCoin,
                  description: e.target.value,
                })
              }
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAdminCoinModal;
